module.exports = __webpack_public_path__ + "static/media/IMG-3026.76afab42.jpg";